<template>
  <div class="detail-item">
    <app-material-icon :name="icon" data-locator="icon" size="xs" type="fa" v-bind="iconAttrs" />
    <dt class="text--bold"  data-locator="title">{{ $t(title) }} :</dt>
    <dd data-locator="content">
      <slot></slot>
    </dd>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'AppGridDetailItem',
  props: {
    icon: {
      type: String as PropType<string>,
      default: '',
    },
    iconAttrs: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({}),
    },
    title: {
      type: String as PropType<string>,
      default: '',
    },
  },
})
</script>

<style scoped lang="scss">
.detail-item {
  column-gap: 6px;
  display: flex;
  align-items: center;

  dd, dt {
    display: flex;
    align-items: center;
    column-gap: 4px;
  }
}
</style>
